import { InsuranceProviders } from '../enums/insurance-providers';
import { useSellerLabelProvider } from './use-seller-label-provider';
import { useIsParcelGuardActivated, useIsXCoverActivated } from '../services/insurance-service';
import { useFulfillmentPlannerContext } from '../fulfillment-planner/context';

export const useDoesCswRequireWalletSetup = () => {
  const { insuranceProvider, serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext() ?? {};

  const { requiresSetup: labelProviderRequiresSetup } =
    useSellerLabelProvider(serviceIdAndSellerLabelProviderId?.sellerLabelProviderId) || {};

  const isPurchasingParcelGuard = insuranceProvider?.insuranceProviderId === InsuranceProviders.ParcelGuard.insuranceProviderId;
  const isParcelGuardActivated = useIsParcelGuardActivated();
  const doesParcelGuardRequireSetup = isPurchasingParcelGuard && !isParcelGuardActivated;
  const isPurchasingXCover = insuranceProvider?.insuranceProviderId === InsuranceProviders.XCover.insuranceProviderId;
  const isXCoverActivated = useIsXCoverActivated();
  const doesXCoverRequireSetup = isPurchasingXCover && !isXCoverActivated;
  const insuranceProviderRequiresSetup = doesParcelGuardRequireSetup || doesXCoverRequireSetup;

  return labelProviderRequiresSetup || insuranceProviderRequiresSetup;
};
